/* eslint-disable react/prop-types */
import React from 'react';
import { MdDelete } from "react-icons/md";
// import { TENANT_COMPANY_MAP } from '../../../utils/constants';
// import { getTenantId } from '../../../utils/helpers';

/** Light chip backgrounds by wall-clock period (24h from type="time"). */
function backgroundClassForMedicineTime(timeString) {
    if (!timeString || typeof timeString !== 'string') return 'bg-slate-50';
    const [hs, ms] = timeString.split(':');
    const h = parseInt(hs, 10);
    const m = parseInt(ms ?? '0', 10);
    if (Number.isNaN(h)) return 'bg-slate-50';
    const mins = h * 60 + (Number.isNaN(m) ? 0 : m);
    // 12:00 AM–11:59 AM
    if (mins <= 11 * 60 + 59) return 'bg-sky-100';
    // 12:00 PM–3:59 PM
    if (mins <= 15 * 60 + 59) return 'bg-amber-100';
    // 4:00 PM–11:59 PM
    return 'bg-violet-100';
}

export default function MedicineTimeContainer({
    updateMedicineTiming,
    ind,
    timing,
    deleteMedicineTiming
}) {
    //const tenantId = getTenantId();
    const isEasydose = false;
    return (
        <>
            {isEasydose ? (
                <div className={`flex flex-row gap-2 rounded-xl border h-12 border-gray-300 py-2 px-2 w-fit items-center ${backgroundClassForMedicineTime(timing.time)}`}>
                    <input
                        className='rounded-xl h-6 border-none text-sm no-clock p-0 focus:outline-none focus:ring-0'
                        type='time'
                        value={timing.time}
                        maxLength={5}
                        name='time'
                        onChange={e => updateMedicineTiming(ind, e.target.name, e.target.value)}
                    />
                    {/* Meal selection - Three options */}
                    <div className='flex flex-row gap-1 items-center'>
                        <button
                            type="button"
                            onClick={() => updateMedicineTiming(ind, "meal", "BEFORE")}
                            className={`px-2 py-1 text-xs rounded ${
                                timing.meal === "BEFORE"
                                    ? 'bg-red-500 text-white'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                            Before
                        </button>
                        <button
                            type="button"
                            onClick={() => updateMedicineTiming(ind, "meal", "AFTER")}
                            className={`px-2 py-1 text-xs rounded ${
                                timing.meal === "AFTER"
                                    ? 'bg-green-500 text-white'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                            After
                        </button>
                        <button
                            type="button"
                            onClick={() => updateMedicineTiming(ind, "meal", "WITH_FOOD")}
                            className={`px-2 py-1 text-xs rounded ${
                                timing.meal === "WITH_FOOD"
                                    ? 'bg-blue-500 text-white'
                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                        >
                            With Food
                        </button>
                    </div>
                    <div className='w-fit'>
                        <MdDelete
                            className='text-gray-400 text-2xl cursor-pointer font-bold'
                            onClick={() => deleteMedicineTiming(ind)}
                        />
                    </div>
                </div>
            ) : (
                <div className={`flex flex-row gap-2 rounded-xl border h-12 border-gray-300 py-2 px-2 w-fit items-center ${backgroundClassForMedicineTime(timing.time)}`}>
                    <input
                        className='rounded-xl h-6 border-none text-sm no-clock p-0 focus:outline-none focus:ring-0'
                        type='time'
                        value={timing.time}
                        maxLength={5}
                        name='time'
                        onChange={e => updateMedicineTiming(ind, e.target.name, e.target.value)}
                    />
                    <label className='text-xs'>Before</label>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            type="checkbox"
                            name='meal'
                            checked={timing.meal === "AFTER"}
                            onChange={e => {
                                if (e.target.checked) {
                                    updateMedicineTiming(ind, "meal", "AFTER");
                                } else {
                                    updateMedicineTiming(ind, "meal", "BEFORE");
                                }
                            }}
                            className="sr-only peer"
                        />
                        <div className={`w-9 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-[9px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-elm-500 border-elm-500 border ${
                            timing.meal !== "AFTER"
                                ? "after:bg-red-500 after:border-red-500"
                                : "after:bg-white-50 after:border-gray-300"
                        }`}></div>
                    </label>
                    <label className='text-xs'>After</label>
                    <div className='w-fit'>
                        <MdDelete
                            className='text-gray-400 text-2xl cursor-pointer font-bold'
                            onClick={() => deleteMedicineTiming(ind)}
                        />
                    </div>
                </div>
            )}
        </>
    );
}